import React from 'react';
import clsx from 'clsx';

import ImageTextOverlay from '@common/ImageTextOverlay';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import * as styles from '@common/blocks/flex/flex.module.scss';

const FlexLinks = ({ data }) => {
  const {
    showImages,
    imagePositionTop,
    imagePositionTopLg,
    imageWidth,
    imageNegativeMargin,
    links
  } = data;
  return (
    <div style={{ marginTop: `-${imageNegativeMargin}` }} className={clsx('d-none d-lg-flex', imageWidth, {
      [`d-none ${showImages}`]: showImages,
      'mb-3 mb-md-0': imagePositionTop,
      'mb-lg-5': imagePositionTopLg,
      [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop,
      'customer-stories-links': links.length > 1
    })}>
    {links.map((link, index) => (
      <div key={index} className={clsx('col', {
          [styles.offsetCards]:index % 2 != 0,
          'me-3': index !== links.length-1
        })}>
        <ImageTextOverlay to={link.link} image={link.image} colour={link.bgColour} aspectRatio={links.length > 1 ? '5/6' : '1/1'}>
          <div className='fs-18 fw-medium' style={{marginBottom:'15px'}}>{link.title}</div>
          <div className='d-flex align-items-center fs-16 fw-normal'>
            <span style={{marginRight: '5px'}}>{link.linkCopy}</span>
            <FontAwesomeIcon icon={faChevronRight} size ='sm'/>
          </div>
        </ImageTextOverlay>
        {link.subtitle && 
          <div className='mt-3 col-lg-9 fw-medium fs-18'>
            {link.subtitle}
          </div>
        }
      </div>
    ))}
  </div>
  )
}

export default FlexLinks
